import React, { useMemo, useState } from 'react';
import { Card, Icon } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { Typography } from 'src/components/Typography';
import { TYPOGRAPHY_WEIGHT } from 'src/components/Typography/types';
import { Pagination } from 'src/components/Pagination';
import { InterviewOption, WorkerInterviewsProps } from './WorkerInterviews.types';

export const WorkerInterviews = ({
  hashAttributes,
  defaultInterviewId,
  interviews,
}: WorkerInterviewsProps) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const { t } = useTranslation();

  const interviewOptions = useMemo((): InterviewOption[] => {
    return [
      {
        interviewId: defaultInterviewId,
        label: t('workerProfile.interview.defaultInterviewLabel'),
      },
      ...(interviews?.map(interview => ({
        interviewId: interview.interviewId,
        label: interview.job.role.name || '',
      })) ?? []),
    ].filter((interview): interview is InterviewOption => !!interview.interviewId);
  }, [defaultInterviewId, interviews]);

  const handlePrev = () => {
    setSelectedIndex(prevIndex => Math.max(prevIndex - 1, 0));
  };

  const handleNext = () => {
    setSelectedIndex(prevIndex => Math.min(prevIndex + 1, interviewOptions.length - 1));
  };

  if (!hashAttributes) return null;

  return (
    <Card>
      <Box py={2} px={2} display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h6" fontWeight={TYPOGRAPHY_WEIGHT.MEDIUM}>
          <Trans>
            {!!interviewOptions.length
              ? 'workerProfile.interview.label'
              : 'workerProfile.interview.noInterviewLabel'}
          </Trans>
          {!!interviewOptions.length && ` (${selectedIndex + 1}/${interviewOptions.length})`}
        </Typography>
        {!!interviewOptions.length && (
          <Typography variant="h6" fontWeight={TYPOGRAPHY_WEIGHT.MEDIUM}>
            {interviewOptions[selectedIndex].label}
          </Typography>
        )}
        {!!interviewOptions.length && (
          <Box>
            <Pagination item onClick={handlePrev}>
              <Icon sx={{ fontWeight: 'bold' }}>chevron_left</Icon>
            </Pagination>
            <Pagination item onClick={handleNext}>
              <Icon sx={{ fontWeight: 'bold' }}>chevron_right</Icon>
            </Pagination>
          </Box>
        )}
      </Box>
      {!!interviewOptions.length && (
        <Box height="400px">
          <iframe
            width="100%"
            height="100%"
            allowFullScreen
            src={`https://embed.myinterview.com/player.v3.html?apiKey=xkqnejs448zhbgzqnuqljpm5&hashTimestamp=${hashAttributes.timestamp}&hash=${hashAttributes.hash}&video=${interviewOptions[selectedIndex].interviewId}&fs=0`}></iframe>
        </Box>
      )}
    </Card>
  );
};
